import MenuDetailsItem from "@Components/buyCarMenu/MenuDetailsItem";
import { setUrlFormat } from "@Lib/common";
import { fetchBuyCarMenuRecommend } from "@Services/buyCarMenu";
import { host } from "@Services/url";
import { IBuyCarMenuRecommend } from "@Types/buyCarMenu";
import { useSetState } from "ahooks";
import React, { useEffect, useRef, useState } from "react";
import { useQuery } from "react-query";

const initData: IBuyCarMenuRecommend = {
  items: [],
  paging: "",
  total: 0,
};

const MenuDetialsList: React.FC<any> = ({ kindId, type, menuId }) => {
  const [items, setItems] = useState<IBuyCarMenuRecommend["items"]>([]);
  const [params, setParams] = useSetState({
    kindName: "",
    brandName: "",
  });
  const { kindName, brandName } = params;

  useQuery<IBuyCarMenuRecommend>([`fetchBuyCarMenuRecommend`, kindId, type, menuId], async () => {
    const res = await fetchBuyCarMenuRecommend({ kindId, limit: 5, type, menuId });

    if (res?.status === 12000) {
      setItems([...res.data.items]);
      setParams(res.data.items[0]);
    }
    return res?.status === 12000 ? res.data : initData;
  });

  return (
    <>
      {items?.length > 0 && (
        <div id='MenuDetialsList'>
          <div className='flex justify-between items-center mb-26 mt-40'>
            <div className='text-20'>推薦購車菜單</div>
          </div>
          {items.map((item: any, index: number) => (
            <MenuDetailsItem
              item={item}
              key={index}
              source={`${type === 1 ? "分享菜單" : "徵求菜單"}詳情頁-推薦購車菜單-徵求此菜單`}
            />
          ))}
          <a
            href={`/menu/${setUrlFormat(brandName)}/${setUrlFormat(kindName)}`}
            target='_blank'
            className='mx-auto text-16 text-[#666] w-380 h-40 flex items-center justify-center bg-[#F5F5F5] mb-20 mt-14 cursor-pointer'
          >
            更多購車菜單
          </a>
        </div>
      )}
    </>
  );
};

export default MenuDetialsList;
